// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oFCwn","footer":"styles_footer__3nf4n"};